import {
  getImagesUrlsAdapted,
  imageUrlAdapterAspectRatios,
  imageUrlAdapterImageTypes,
  imageUrlAdapterTransformTypes
} from '@adv-mt/mt-hook-use-image-url-adapter'

const adaptDomainFeedImage = ({domainConfig, img, imageType, imageWidth}) => {
  const {ARTICLE_CARD_IMAGE_WIDTH_M} = domainConfig.get('editorial')

  const mainArticleImageUpdated = getImagesUrlsAdapted({
    images: [{src: img}],
    options: {
      aspectRatio: imageUrlAdapterAspectRatios.WIDE_SCREEN,
      imageWidth: imageWidth || ARTICLE_CARD_IMAGE_WIDTH_M,
      imageType: imageType || imageUrlAdapterImageTypes.CARD_M,
      transformType: imageUrlAdapterTransformTypes.DEVICE_CROP
    }
  })

  return mainArticleImageUpdated[0].src
}

export const adaptDomainNewsFeed = ({domainConfig, newsFeed}) => {
  const items = newsFeed?.items ?? []
  return {
    ...newsFeed,
    items: items.map(item => ({
      ...item,
      img: adaptDomainFeedImage({
        domainConfig,
        img: item.img,
        getImagesUrlsAdapted
      })
    }))
  }
}
